document.addEventListener("DOMContentLoaded", function () {
  let shareLinks = document.querySelectorAll(".share-link");

  if (shareLinks.length > 0) {
    shareLinks.forEach(function (shareLink) {
      shareLink.addEventListener("click", function () {
        let tempInput = document.createElement("input");
        document.body.appendChild(tempInput);

        let currentUrl = window.location.href;
        tempInput.value = currentUrl;
        tempInput.select();
        document.execCommand("copy");
        document.body.removeChild(tempInput);

        let messageSpan = document.createElement("span");
        messageSpan.className = "text";
        messageSpan.textContent = "URL Copied";

        shareLink.appendChild(messageSpan);

        setTimeout(function () {
          shareLink.removeChild(messageSpan);
        }, 2500);
      });
    });
  }
});
